import { render } from "./BaseSuccessMessage.vue?vue&type=template&id=3e92de1d&scoped=true"
import script from "./BaseSuccessMessage.vue?vue&type=script&lang=js"
export * from "./BaseSuccessMessage.vue?vue&type=script&lang=js"

import "./BaseSuccessMessage.vue?vue&type=style&index=0&id=3e92de1d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e92de1d"]])

export default __exports__